module.exports = __webpack_public_path__ + "media/images/pages/peel/heart-0540f605b72f209c432eccf2a7436219.svg";